export default __webpack_public_path__ + "static/media/stephanie_on.523d408c.png";